// Common initialization for browsers

import jQuery from "jquery";

import { kibelaCookie } from "./utils/kibelaCookie";
import { logException } from "./utils/log_exception";
import "./zendesk";

window.$ = window.jQuery = jQuery;

require("jquery-ujs");

require("./utils/contactWidgetOpener");

const NODE_ENV = process.env.NODE_ENV || "";
if (process.env.NEWRELIC_KEY) {
  try {
    newrelic.addRelease(NODE_ENV, process.env.COMMIT_HASH as string);
  } catch (e) {
    logException(e);
  }
}

// this `cookie.set`s must be after initialization of Raven
kibelaCookie.set("timezone_offset", (-(new Date().getTimezoneOffset() / 60)).toString());
try {
  kibelaCookie.set("timezone_name", Intl.DateTimeFormat().resolvedOptions().timeZone);
} catch (e) {
  // In case the browser does not support Intl.DateTimeFormat
  logException(e);
}
